module.exports = __webpack_public_path__ + "media/points/deliver-2d2ab4b7.svg";